import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes

import { canNavigate } from '@/libs/ability/routeProtection'
import store from '@/store'
import modules from '@/router/routes/modules'
import maps from '@/router/routes/maps'

import ui from '@/router/routes/ui-elements/ui'
import auth from './routes/auth'
import dashboard from './routes/dashboard'
import reports from "./routes/reports"
import plans from "./routes/plans"
import rain from "./routes/plans/rain"
import sweep from "./routes/plans/sweep"
import dump from "./routes/plans/dump"
import washer from "./routes/plans/washer"
import utility from "./routes/plans/utility"
import landfill from './routes/plans/landfill'

import supportDevice from "./routes/plans/supportDevice"
import drainage from './routes/plans/drainage'
import network from './routes/plans/network'
import wasl from "./routes/wasl"
import pest from "./routes/plans/pest"
import gplans from "./routes/gplans"

import wash from './routes/plans/wash'

import containerDump from './routes/plans/containerDump'
import containerWash from './routes/plans/containerWash'
import containerArea from './routes/plans/containerArea'
import containerPest from './routes/plans/containerPest'

// Field Services
import installation from "./routes/fieldServices/installation"
import compactorPath from '@/router/routes/compactor-path'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: 'dashboard' },
    ...dashboard,
    ...auth,
    ...maps,
    ...modules,

    ...reports,
    ...plans,
    ...rain,
    ...sweep,
    ...washer,
    ...pest,
    ...supportDevice,
    ...drainage,
    ...network,
    ...wash,
    ...containerDump,
    ...containerWash,
    ...containerArea,
    ...containerPest,
    ...dump,
    ...utility,
    ...landfill,
    ...ui,
    ...wasl,
    ...gplans,
    ...installation,
    ...compactorPath,

    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.auth.userData

  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'auth-login', query:{redirect:to.fullPath}})
    return next({ name: 'not-authorized' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    if(to.query.redirect !== undefined) {
      return next({path:to.query.redirect})
    }
    return next({ name: 'dashboard' })
  }

  return next()

})

export default router
